export default __webpack_public_path__ + "static/media/AnodizingImg.22f01b00.jpg";